export default __webpack_public_path__ + "static/media/remove-new-icon.3c90ddfe.svg";